import type { ContentSummaryLink, AgentHitType } from '~/types/agent';

import Button from '@helsenorge/designsystem-react/components/Button';
import Icon from '@helsenorge/designsystem-react/components/Icon';
import ArrowRight from '@helsenorge/designsystem-react/components/Icons/ArrowRight';
import Spacer from '@helsenorge/designsystem-react/components/Spacer';
import designsystemtypography from '@helsenorge/designsystem-react/scss/typography.module.scss';

import { IconSize } from '@helsenorge/designsystem-react';

import styles from './styles.module.scss';

import { getSearchHitUrl } from '~/cmsagent/components/search-hit/utils';

interface TjenesterProps {
  links: ContentSummaryLink[];
  returnUrlText: string;
  onResultClick?: (title: string, hitType: AgentHitType) => void;
  resources: {
    goToTjeneste: string;
    goToVerktoy: string;
  };
  returnUrl: string;
}

const Tjenester: React.FC<TjenesterProps> = props => {
  return (
    <div className={styles.tjenester}>
      {props.links.map(link => {
        const goToLinkText = link.hitType === 'verktoy' ? props.resources.goToVerktoy : props.resources.goToTjeneste;

        return (
          <div key={link.url} className={styles.tjeneste}>
            <h3 className={designsystemtypography.body}>{link.title}</h3>
            <p className={designsystemtypography.body}>{link.description}</p>
            <Spacer size="xs" />
            <Button
              type="button"
              htmlMarkup="a"
              variant="borderless"
              ariaLabel={goToLinkText}
              href={getSearchHitUrl(link.url, props.returnUrlText, props.returnUrl)}
              onClick={() => props.onResultClick?.(link.title, link.hitType)}
            >
              <div>{goToLinkText} </div>
              <Icon svgIcon={ArrowRight} size={IconSize.Medium} />
            </Button>
          </div>
        );
      })}
    </div>
  );
};

export default Tjenester;
